import type { Subject } from '../../types/game';
import clsx from 'clsx';

interface SubjectSelectorProps {
  subjects: Subject[];
  selectedId: number | null;
  usedSubjects: number[];
  onSelect: (id: number) => void;
}

export const SubjectSelector = ({
  subjects,
  selectedId,
  usedSubjects,
  onSelect,
}: SubjectSelectorProps) => {
  return (
    <div className="flex flex-wrap gap-4 justify-center">
      {subjects.map(subject => {
        const isUsed = usedSubjects.includes(subject.id);
        const isSelected = selectedId === subject.id;
        const isDisabled = isUsed && !isSelected;

        return (
          <button
            key={subject.id}
            onClick={() => !isDisabled && onSelect(subject.id)}
            disabled={isDisabled}
            className={clsx(
              'px-8 py-4 rounded-xl font-black uppercase text-lg transition-all duration-100 relative overflow-hidden',
              'disabled:opacity-40 disabled:cursor-not-allowed disabled:translate-x-1 disabled:translate-y-1 disabled:shadow-none',
              'border-2 border-white',
              isSelected
                ? 'text-black shadow-none translate-x-[4px] translate-y-[4px]'
                : 'text-white bg-bg-surface shadow-[6px_6px_0_white] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0_white]'
            )}
            style={{
              background: isSelected ? subject.color : 'var(--color-bg-deep)',
            }}
          >
            <span className="relative z-10">{subject.name}</span>
            {isUsed && (
              <span className="ml-2 text-lg relative z-10">✓</span>
            )}
            {!isDisabled && !isSelected && (
              <span
                className="absolute inset-0 opacity-0 hover:opacity-10 rounded-xl transition-opacity"
                style={{ background: subject.color }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
